import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionType } from './subscription-type.model';
import { SubscriptionTypeService } from './subscription-type.service';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class SubscriptionTypePopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private subscriptionTypeService: SubscriptionTypeService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.subscriptionTypeService.find(id).subscribe(subscriptionType => {
                this.subscriptionTypeModalRef(component, subscriptionType);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.subscriptionTypeModalRef(component, new SubscriptionType());
            });
        }
    }

    subscriptionTypeModalRef(component: Component, subscriptionType: SubscriptionType): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.subscriptionType = subscriptionType;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type-popup.service.ts